// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"16e168b8","94":"091aa56c","184":"ac595c67","338":"bd611567","388":"d715f230","427":"872d7d54","446":"b8b8a4ed","562":"e413290f","600":"e7949cae","785":"f18da150","879":"20754a67"}[chunkId] + ".chunk.js";
};